import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { Component } from 'react';
import { css, jsx } from '@emotion/react';
import { N300 } from '@atlaskit/theme/colors';
import ColumnCell from './internal/common-cell';
import withColumnWidth from './internal/with-column-width';
const headerStyles = css({
  color: `var(--ds-text-subtle, ${N300})`,
  fontSize: "var(--ds-font-size-075, 12px)",
  fontWeight: "var(--ds-font-weight-bold, bold)",
  letterSpacing: -0.1,
  lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
class Header extends Component {
  render() {
    const {
      props
    } = this;
    return (
      // TODO: Determine whether proper `th` elements can be used instead of
      // roles (DSP-11588)
      jsx(ColumnCell, _extends({
        css: headerStyles,
        role: "columnheader",
        style: {
          width: props.width
        }
      }, props), props.children)
    );
  }
}
export default withColumnWidth(Header);